import React from "react";
// import { merge } from "lodash";
//import AgoraRTC from "agora-rtc-sdk";
// import AgoraRTC from "agora-rtc-sdk-ng";

import { isMobile } from "react-device-detect";

import "./agora_canvas.css";
import "../assets/fonts/css/icons.css";

/*
import IconButton from '@material-ui/core/IconButton';
import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExit from '@material-ui/icons/FullscreenExit';
*/

const tile_canvas = {
  "1": ["span 12/span 24"],
  "2": ["span 12/span 12/13/25", "span 12/span 12/13/13"],
  "3": ["span 6/span 12", "span 6/span 12", "span 6/span 12/7/19"],
  "4": [
    "span 6/span 12",
    "span 6/span 12",
    "span 6/span 12",
    "span 6/span 12/7/13",
  ],
  "5": [
    "span 3/span 4/13/9",
    "span 3/span 4/13/13",
    "span 3/span 4/13/17",
    "span 3/span 4/13/21",
    "span 9/span 16/10/21",
  ],
  "6": [
    "span 3/span 4/13/7",
    "span 3/span 4/13/11",
    "span 3/span 4/13/15",
    "span 3/span 4/13/19",
    "span 3/span 4/13/23",
    "span 9/span 16/10/21",
  ],
  "7": [
    "span 3/span 4/13/5",
    "span 3/span 4/13/9",
    "span 3/span 4/13/13",
    "span 3/span 4/13/17",
    "span 3/span 4/13/21",
    "span 3/span 4/13/25",
    "span 9/span 16/10/21",
  ],
};

/**
 * @prop appId uid
 * @prop transcode attendeeMode videoProfile channel baseMode
 */
class AgoraCanvas extends React.Component {
  constructor(props) {
    super(props);
    this.client = {};
    this.localStream = {};
    this.shareClient = {};
    this.shareStream = {};
    this.state = {
      displayMode: "pip",
      //streamList: props.subscribers || [],
      fullscreen: false,
      readyState: true,
      micStatus: true
      //stateSharing: false,
    };
  }

  /*
  componentWillMount() {
    let $ = this.props;
    // init AgoraRTC local client
    this.client = AgoraRTC.createClient({ mode: $.transcode });
    this.client.init($.appId, () => {
      console.log("AgoraRTC client initialized");
      this.subscribeStreamEvents();
      this.client.join($.appId, $.channel, $.uid, (uid) => {
        this.state.uid = uid;
        console.log("User " + uid + " join channel successfully");
        console.log("At " + new Date().toLocaleTimeString());
        // create local stream
        // It is not recommended to setState in function addStream
        this.localStream = this.streamInit(uid, $.attendeeMode, $.videoProfile);
        this.localStream.init(
          () => {
            if ($.attendeeMode !== "audience") {
              this.addStream(this.localStream, true);
              this.client.publish(this.localStream, (err) => {
                console.log("Publish local stream error: " + err);
              });
            }
            this.setState({ readyState: true });
          },
          (err) => {
            console.log("getUserMedia failed", err);
            this.setState({ readyState: true });
          }
        );
      });
    });
  }
  */

  componentDidMount() {
    // add listener to control btn group
    let canvas = document.querySelector("#ag-canvas");
    let btnGroup = document.querySelector(".ag-btn-group");
    canvas.addEventListener("mousemove", () => {
      if (global._toolbarToggle) {
        clearTimeout(global._toolbarToggle);
      }
      btnGroup.classList.add("active");
      global._toolbarToggle = setTimeout(function () {
        btnGroup.classList.remove("active");
      }, 2000);
    });
  }

  // componentWillUnmount () {
  //     // remove listener
  //     let canvas = document.querySelector('#ag-canvas')
  //     canvas.removeEventListener('mousemove')
  // }

  componentDidUpdate(prevProps) {
    // rerendering
    //console.log("AgoraCanvas componentDidUpdate",this.state.displayMode,this.props.streamList);
    let canvas = document.querySelector("#ag-canvas");
    
    // first remove any missing streams
    prevProps.streamList.map((item, index) => {
      // is this in new streamList?
      if (this.props.streamList.some( (element) => element.uid === item.uid)) {
        return;
      }
      
      // not in new stream list - remove the dom element
      let element = document.querySelector("#ag-item-" + item.uid);
      if (element) {
        element.parentNode.removeChild(element);
      }    
    });
    
    // pip mode (can only use when less than 4 people in channel)
    if (this.state.displayMode === "pip") {
      //let no = this.state.streamList.length;
      let no = this.props.streamList.length;
      if (no > 4) {
        this.setState({ displayMode: "tile" });
        return;
      }
      this.props.streamList.map((item, index) => {
        //let id = item.getId();
        //console.log(" streamList",item.uid,item.hasVideo,typeof item.videoTrack);
        
        if (item.hasVideo && item.videoTrack) {
        
          let id = item.uid;
          let dom = document.querySelector("#ag-item-" + id);
          if (!dom) {
            //console.log("  BUILDING DOM OBJECT");
            dom = document.createElement("section");
            dom.setAttribute("id", "ag-item-" + id);
            dom.setAttribute("class", "ag-item");
            canvas.appendChild(dom);
            //item.play("ag-item-" + id);
            
              //console.log("  PLAYING");
              //item.videoTrack.play("ag-item-" + id);
            
          } else {
            //console.log("  DOM OBJECT EXISTS");
          }
          if (index === no - 1) {
            dom.setAttribute("style", `grid-area: span 12/span 24/13/25`);
          } else {
            dom.setAttribute(
              "style",
              `grid-area: span 3/span 4/${4 + 3 * index}/25;
                      z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            );
          }
        }
        
        //item.player.resize && item.player.resize();
      });
    }
    // tile mode
    else if (this.state.displayMode === "tile") {
      //let no = this.state.streamList.length;
      let no = this.props.streamList.length;
      this.props.streamList.map((item, index) => {
        //let id = item.getId();
        let id = item.uid;
        let dom = document.querySelector("#ag-item-" + id);
        if (!dom) {
          dom = document.createElement("section");
          dom.setAttribute("id", "ag-item-" + id);
          dom.setAttribute("class", "ag-item");
          canvas.appendChild(dom);
          //item.play("ag-item-" + id);
          //if (item.hasVideo && item.videoTrack) {
            //item.videoTrack.play("ag-item-" + id);
          //}
        }
        dom.setAttribute("style", `grid-area: ${tile_canvas[no][index]}`);
        //item.player.resize && item.player.resize();
      });
    }
    // screen share mode (tbd)
    else if (this.state.displayMode === "share") {
    }
    
    this.props.streamList.map((item, index) => {
      //console.log("Setup overlay for item",item);
      let dom = document.querySelector("#ag-item-" + item.uid);
      if (dom) {

        let off_flag = '-slash';
        if (index !== 0 && (item.hasAudio && item.audioTrack)) {
          item.audioTrack.play();
          off_flag = '';
        }
        if (index === 0) {
          if (this.state.micStatus) {
            off_flag = '';
          }
        }

        let overlay_dom = document.querySelector("#ag-item-overlay-" + item.uid);
        let nickname_dom = document.querySelector("#ag-item-overlay-nickname-" + item.uid);
        let mic_dom = document.querySelector("#ag-item-overlay-mic-" + item.uid);

        if (!overlay_dom) {
          overlay_dom = document.createElement("div");
          overlay_dom.setAttribute("id", "ag-item-overlay-" + item.uid);
          overlay_dom.setAttribute("class","overlay-desc");
          dom.appendChild(overlay_dom);
        }

        if (!nickname_dom) {
          nickname_dom = document.createElement("span");
          nickname_dom.setAttribute("id", "ag-item-overlay-nickname-" + item.uid);
          //nickname_dom.setAttribute("style","padding-right: 5px; font-size: 2vw; display: block");
          nickname_dom.innerText = item.nickname;
          overlay_dom.appendChild(nickname_dom);
        }

        if (!mic_dom) {
          mic_dom = document.createElement("i");
          mic_dom.setAttribute("id","ag-item-overlay-mic-"+item.uid);
          mic_dom.setAttribute("style","font-size: 2vw;");
          overlay_dom.appendChild(mic_dom);
        }

        if (this.state.displayMode === "tile" || index === this.props.streamList.length - 1) {
          nickname_dom.setAttribute("style","padding-right: 5px; font-size: 2vw; display: inline");
        } else if (this.state.displayMode === "pip" && index !== this.props.streamList.length - 1) {
          nickname_dom.setAttribute("style","display: none");
        }
        
        mic_dom.setAttribute("class","fa fa-microphone"+off_flag);
        
        if (item.videoTrack) {
          if (item.hasVideo) {
            item.videoTrack.play("ag-item-" + item.uid);
          //} else {
            //item.videoTrack.stop();
          }
        }
      }
    });
    
  }

  /*
  componentWillUnmount() {
    this.client && this.client.unpublish(this.localStream);
    this.localStream && this.localStream.close();
    if (this.state.stateSharing) {
      this.shareClient && this.shareClient.unpublish(this.shareStream);
      this.shareStream && this.shareStream.close();
    }
    this.client &&
      this.client.leave(
        () => {
          console.log("Client succeed to leave.");
        },
        () => {
          console.log("Client failed to leave.");
        }
      );
  }
  */

  /*
  streamInit = (uid, attendeeMode, videoProfile, config) => {
    let defaultConfig = {
      streamID: uid,
      audio: true,
      video: true,
      screen: false,
    };

    switch (attendeeMode) {
      case "audio-only":
        defaultConfig.video = false;
        break;
      case "audience":
        defaultConfig.video = false;
        defaultConfig.audio = false;
        break;
      default:
      case "video":
        break;
    }

    let stream = AgoraRTC.createStream(merge(defaultConfig, config));
    stream.setVideoProfile(videoProfile);
    return stream;
  };
  */

  /*
  subscribeStreamEvents = () => {
    let rt = this;
    rt.client.on("stream-added", function (evt) {
      let stream = evt.stream;
      console.log("New stream added: " + stream.getId());
      console.log("At " + new Date().toLocaleTimeString());
      console.log("Subscribe ", stream);
      rt.client.subscribe(stream, function (err) {
        console.log("Subscribe stream failed", err);
      });
    });

    rt.client.on("peer-leave", function (evt) {
      console.log("Peer has left: " + evt.uid);
      console.log(new Date().toLocaleTimeString());
      console.log(evt);
      rt.removeStream(evt.uid);
    });

    rt.client.on("stream-subscribed", function (evt) {
      let stream = evt.stream;
      console.log("Got stream-subscribed event");
      console.log(new Date().toLocaleTimeString());
      console.log("Subscribe remote stream successfully: " + stream.getId());
      console.log(evt);
      rt.addStream(stream);
    });

    rt.client.on("stream-removed", function (evt) {
      let stream = evt.stream;
      console.log("Stream removed: " + stream.getId());
      console.log(new Date().toLocaleTimeString());
      console.log(evt);
      rt.removeStream(stream.getId());
    });
  };

  removeStream = (uid) => {
    this.state.streamList.map((item, index) => {
      if (item.getId() === uid) {
        item.close();
        let element = document.querySelector("#ag-item-" + uid);
        if (element) {
          element.parentNode.removeChild(element);
        }
        let tempList = [...this.state.streamList];
        tempList.splice(index, 1);
        this.setState({
          streamList: tempList,
        });
      }
    });
  };

  addStream = (stream, push = false) => {
    let repeatition = this.state.streamList.some((item) => {
      return item.getId() === stream.getId();
    });
    if (repeatition) {
      return;
    }
    if (push) {
      this.setState({
        streamList: this.state.streamList.concat([stream]),
      });
    } else {
      this.setState({
        streamList: [stream].concat(this.state.streamList),
      });
    }
  };

  */
  
  handleCamera = (e) => {
    e.currentTarget.classList.toggle("off");
    
    if (this.props.camStatusChanged) {
      this.props.camStatusChanged();
    }
    //this.localStream.isVideoOn()
    //  ? this.localStream.disableVideo()
    //  : this.localStream.enableVideo();
  };

  handleMic = (e) => {
    e.currentTarget.classList.toggle("off");
    this.setState({ micStatus: !this.state.micStatus });
    
    if (this.props.micStatusChanged) {
      this.props.micStatusChanged();
    }
    //this.localStream.isAudioOn()
    //  ? this.localStream.disableAudio()
    //  : this.localStream.enableAudio();
  };
  

  switchDisplay = (e) => {
    if (
      e.currentTarget.classList.contains("disabled") ||
      this.props.streamList.length <= 1
    ) {
      return;
    }
    if (this.state.displayMode === "pip") {
      this.setState({ displayMode: "tile" });
    } else if (this.state.displayMode === "tile") {
      this.setState({ displayMode: "pip" });
    } else if (this.state.displayMode === "share") {
      // do nothing or alert, tbd
    } else {
      console.error("Display Mode can only be tile/pip/share");
    }
  };

  hideRemote = (e) => {
    if (
      e.currentTarget.classList.contains("disabled") ||
      this.props.streamList.length <= 1
    ) {
      return;
    }
    let list;
    //let id = this.props.streamList[this.props.streamList.length - 1].getId();
    let id = this.props.streamList[this.props.streamList.length - 1].uid;
    list = Array.from(
      document.querySelectorAll(`.ag-item:not(#ag-item-${id})`)
    );
    list.map((item) => {
      if (item.style.display !== "none") {
        item.style.display = "none";
      } else {
        item.style.display = "block";
      }
    });
  };

  handleExit = (e) => {
    if (e.currentTarget.classList.contains("disabled")) {
      return;
    }
    
    this.props.streamList.map((item, index) => {
        const playerContainer = document.getElementById('ag-item-'+item.uid);
        playerContainer && playerContainer.remove();
    });
    
    if (this.props.leaveSession) {
      this.props.leaveSession();
    }
    /*
    try {
      this.client && this.client.unpublish(this.localStream);
      this.localStream && this.localStream.close();
      if (this.state.stateSharing) {
        this.shareClient && this.shareClient.unpublish(this.shareStream);
        this.shareStream && this.shareStream.close();
      }
      this.client &&
        this.client.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
    } finally {
      this.setState({ readyState: false });
      this.client = null;
      this.localStream = null;
      // redirect to index
      window.location.hash = "";
    }
    */
  };

  sharingScreen = (e) => {
    //return; // JBB FIX HERE
    //console.log('sharingScreen',this.state.stateSharing);
    if (this.props.shareScreen) {
      this.props.shareScreen();
      //this.setState({ stateSharing: !this.state.stateSharing });
    }
  }
  
  /*
  sharingScreen = (e) => {  
    if (this.state.stateSharing) {
      this.shareClient && this.shareClient.unpublish(this.shareStream);
      this.shareStream && this.shareStream.close();
      this.state.stateSharing = false;
    } else {
      this.state.stateSharing = true;
      let $ = this.props;
      // init AgoraRTC local client
      this.shareClient = AgoraRTC.createClient({ mode: $.transcode });
      this.shareClient.init($.appId, () => {
        console.log("AgoraRTC client initialized");
        this.subscribeStreamEvents();
        this.shareClient.join($.appId, $.channel, $.uid, (uid) => {
          this.state.uid = uid;
          console.log("User " + uid + " join channel successfully");
          console.log("At " + new Date().toLocaleTimeString());
          // create local stream
          // It is not recommended to setState in function addStream
          this.shareStream = this.streamInitSharing(
            uid,
            $.attendeeMode,
            $.videoProfile
          );
          this.shareStream.init(
            () => {
              if ($.attendeeMode !== "audience") {
                this.addStream(this.shareStream, true);
                this.shareClient.publish(this.shareStream, (err) => {
                  console.log("Publish local stream error: " + err);
                });
              }
              this.setState({ readyState: true });
            },
            (err) => {
              console.log("getUserMedia failed", err);
              this.setState({ readyState: true });
            }
          );
        });
      });
    }
  };
  */

  /*
  streamInitSharing = (uid, attendeeMode, videoProfile, config) => {
    let defaultConfig = {
      streamID: uid,
      audio: true,
      video: false,
      screen: true,
    };

    switch (attendeeMode) {
      case "audio-only":
        defaultConfig.video = false;
        break;
      case "audience":
        defaultConfig.video = false;
        defaultConfig.audio = false;
        break;
      default:
      case "video":
        break;
    }

    let stream = AgoraRTC.createStream(merge(defaultConfig, config));
    stream.setVideoProfile(videoProfile);
    return stream;
  };
  */
  
    toggleFullscreen = () => {
        this.setState({ fullscreen: !this.state.fullscreen });
        const document = window.document;
        const fs = document.getElementById('ag-canvas');
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement &&
            !document.msFullscreenElement
        ) {
            if (fs.requestFullscreen) {
                fs.requestFullscreen();
            } else if (fs.msRequestFullscreen) {
                fs.msRequestFullscreen();
            } else if (fs.mozRequestFullScreen) {
                fs.mozRequestFullScreen();
            } else if (fs.webkitRequestFullscreen) {
                fs.webkitRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }

  render() {
    const style = {
      display: "grid",
      gridGap: "10px",
      alignItems: "center",
      justifyItems: "center",
      gridTemplateRows: "repeat(12, auto)",
      gridTemplateColumns: "repeat(24, auto)",
      //marginTop: "50px"
    };
    const videoControlBtn =
      this.props.attendeeMode === "video" ? (
        <span
          onClick={this.handleCamera}
          className="ag-btn videoControlBtn"
          title="Enable/Disable Video"
        >
          <i className="ag-icon ag-icon-camera"></i>
          <i className="ag-icon ag-icon-camera-off"></i>
        </span>
      ) : (
        ""
      );

    const audioControlBtn =
      this.props.attendeeMode !== "audience" ? (
        <span
          onClick={this.handleMic}
          className="ag-btn audioControlBtn"
          title="Enable/Disable Audio"
        >
          <i className="ag-icon ag-icon-mic"></i>
          <i className="ag-icon ag-icon-mic-off"></i>
        </span>
      ) : (
        ""
      );

    const switchDisplayBtn = (
      <span
        onClick={this.switchDisplay}
        className={
          this.props.streamList.length > 4
            ? "ag-btn displayModeBtn disabled"
            : "ag-btn displayModeBtn"
        }
        title="Switch Display Mode"
      >
        <i className="ag-icon ag-icon-switch-display"></i>
      </span>
    );
    const hideRemoteBtn = (
      <span
        className={
          this.props.streamList.length > 4 || this.state.displayMode !== "pip"
            ? "ag-btn disableRemoteBtn disabled"
            : "ag-btn disableRemoteBtn"
        }
        onClick={this.hideRemote}
        title="Hide Remote Stream"
      >
        <i className="ag-icon ag-icon-remove-pip"></i>
      </span>
    );
    const exitBtn = (
      <span
        onClick={this.handleExit}
        className={
          this.state.readyState ? "ag-btn exitBtn" : "ag-btn exitBtn disabled"
        }
        title="Exit"
      >
        <i className="ag-icon ag-icon-leave"></i>
      </span>
    );
    const sharingScreenBtn = isMobile ? <React.Fragment></React.Fragment> : (
      <span
        onClick={this.sharingScreen}
        className="ag-btn shareScreenBtn"
        title="Share/unShare Screen"
      >
        <i className="ag-icon ag-icon-screen-share"></i>
      </span>
    );
    
    const fullScreenBtn = (
      <span
        onClick={this.toggleFullscreen}
        className="ag-btn ag-btn-fullscreen"
        title="Toggle Fullscreen"
      >
        <i className="fa fa-arrows-alt" aria-hidden="true"></i>
      </span>
    );
    
    /*
    const fullScreenBtnNope = (
      <IconButton color="inherit" className="ag-btn" onClick={this.toggleFullscreen}>
          {this.state.fullscreen ? <FullscreenExit /> : <Fullscreen />}
      </IconButton>
    );
    */
    
    return (
      <div id="ag-canvas" style={style}>
        <div className="ag-btn-group">
          {exitBtn}
          {videoControlBtn}
          {audioControlBtn}
          {sharingScreenBtn}
          {switchDisplayBtn}
          {fullScreenBtn}
          {/*{hideRemoteBtn}*/}
        </div>
      </div>
    );
  }
}

export default AgoraCanvas;